import Vue from 'vue';
import i18n from '@/services/i18n';
import DictCivilPositionIncRateListPagePage from './DictCivilPositionIncRateListPage.vue';
import DictPositionListPage from './DictPositionListPage.vue';
import DictPositionMvdSalaryListPage from './DictPositionMvdSalaryListPage.vue';
import DictPositionSalaryListPage from './DictPositionSalaryListPage.vue';
import DictPositionVariantsListPage from './DictPositionVariantsListPage.vue';
import DictStRepFormColListPage from './DictStRepFormColListPage.vue';
import DictStRepFormColGroupListPage from './DictStRepFormColGroupListPage.vue';
import DictWorkPositionIncRateListPage from './DictWorkPositionIncRateListPage.vue';
import DictWorkPositionRankListPage from './DictWorkPositionRankListPage.vue';


export type DictDefinitionKey =
    'dict_civil_position_inc_rate'
    | 'dict_position' | 'dict_position_mvd_salary' | 'dict_position_salary' | 'dict_position_variants'
    | 'dict_st_rep_form_col' | 'dict_st_rep_form_col_group'
    | 'dict_work_position_inc_rate' | 'dict_work_position_rank'
;

export interface DictDefinition {
    readonly key: DictDefinitionKey;
    readonly title: string;
    readonly component: typeof Vue;
}

export const dictDefinitions: Array<DictDefinition> = [
    // dict_civil_position_inc_rate - Повышающие коэффициенты гражданских должностей
    {
        get key(): 'dict_civil_position_inc_rate' {
            return 'dict_civil_position_inc_rate';
        },
        get title(): string {
            return i18n.choose(
                'Повышающие коэффициенты гражданских должностей',
                'Азаматтық лауазымдар бойынша коэффициенттерді арттыру',
                'Increasing coefficients for civil positions',
            );
        },
        get component(): typeof Vue {
            return DictCivilPositionIncRateListPagePage;
        },
    },

    // dict_position - Должности госслужащих
    {
        get key(): 'dict_position' {
            return 'dict_position';
        },
        get title(): string {
            return i18n.choose(
                'Должности госслужащих',
                'Мемлекеттік қызметші лауазымдары',
                'Civil servant positions',
            );
        },
        get component(): typeof Vue {
            return DictPositionListPage;
        },
    },

    // dict_position_mvd_salary - Должностные оклады для госслужащих АГС МВД
    {
        get key(): 'dict_position_mvd_salary' {
            return 'dict_position_mvd_salary';
        },
        get title(): string {
            return i18n.choose(
                'Должностные оклады для госслужащих АГС МВД',
                'Ішкі істер министрлігінің Бас инспекторының мемлекеттік қызметшілерінің жалақысы',
                'Salaries for civil servants of the AGS of the Ministry of Internal Affairs',
            );
        },
        get component(): typeof Vue {
            return DictPositionMvdSalaryListPage;
        },
    },

    // dict_position_salary - Должностные оклады
    {
        get key(): 'dict_position_salary' {
            return 'dict_position_salary';
        },
        get title(): string {
            return i18n.choose(
                'Должностные оклады',
                'Ресми жалақылар',
                'Official salaries',
            );
        },
        get component(): typeof Vue {
            return DictPositionSalaryListPage;
        },
    },

    // dict_position_variants - Варианты должностей госслужащих
    {
        get key(): 'dict_position_variants' {
            return 'dict_position_variants';
        },
        get title(): string {
            return i18n.choose(
                'Варианты должностей госслужащих',
                'Мемлекеттік қызметтегі жұмыс нұсқалары',
                'Civil Service Job Options',
            );
        },
        get component(): typeof Vue {
            return DictPositionVariantsListPage;
        },
    },

    // dict_st_rep_form_col - Колонки отчетов штатного расписания
    {
        get key(): 'dict_st_rep_form_col' {
            return 'dict_st_rep_form_col';
        },
        get title(): string {
            return i18n.choose(
                'Колонки отчетов штатного расписания',
                'Қызметкерлер туралы есеп бағандары',
                'Staffing report columns',
            );
        },
        get component(): typeof Vue {
            return DictStRepFormColListPage;
        },
    },

    // dict_st_rep_form_col_group - Группы колонок отчетов штатного расписания
    {
        get key(): 'dict_st_rep_form_col_group' {
            return 'dict_st_rep_form_col_group';
        },
        get title(): string {
            return i18n.choose(
                'Группы колонок отчетов штатного расписания',
                'Қызметкерлер туралы есептің баған топтары',
                'Staffing report column groups',
            );
        },
        get component(): typeof Vue {
            return DictStRepFormColGroupListPage;
        },
    },

    // dict_work_position_inc_rate - Поправочные коэффициенты рабочих должностей
    {
        get key(): 'dict_work_position_inc_rate' {
            return 'dict_work_position_inc_rate';
        },
        get title(): string {
            return i18n.choose(
                'Поправочные коэффициенты рабочих должностей',
                'Лауазымдық лауазымдар үшін түзету факторлары',
                'Correction rates for work positions',
            );
        },
        get component(): typeof Vue {
            return DictWorkPositionIncRateListPage;
        },
    },

    // dict_work_position_rank - Квалификационные разряды для рабочих должностей
    {
        get key(): 'dict_work_position_rank' {
            return 'dict_work_position_rank';
        },
        get title(): string {
            return i18n.choose(
                'Квалификационные разряды для рабочих должностей',
                'Көк жағалы лауазымдарға арналған біліктілік деңгейлері',
                'Qualification levels for blue-collar positions',
            );
        },
        get component(): typeof Vue {
            return DictWorkPositionRankListPage;
        },
    },
];
Object.freeze(dictDefinitions);

export const dictDefinitionKeys: Array<DictDefinitionKey> = [];
export const dictDefinitionMap: Record<DictDefinitionKey, DictDefinition> = ({} as unknown as Record<DictDefinitionKey, DictDefinition>);
dictDefinitions.forEach(definition => {
    const key = definition.key;
    dictDefinitionKeys.push(key);
    dictDefinitionMap[key] = definition;
});
Object.freeze(dictDefinitionKeys);
Object.freeze(dictDefinitionMap);